export const routes = {
  home: {
    route: '/',
    buildRoute: () => `/`,
  },
  dashboard: {
    route: '/dashboard',
    buildRoute: () => `/dashboard`,
  },
  calendar: {
    route: '/calendar',
    buildRoute: () => `/calendar`,
  },
  projects: {
    route: '/projects',
    buildRoute: () => `/projects`,
  },
  connections: {
    route: '/connections',
    buildRoute: () => `/connections`,
  },
  subscriptions: {
    root: {
      route: '/subscriptions',
      buildRoute: () => `/subscriptions`,
    },
  },
  settings: {
    root: {
      route: '/settings',
      buildRoute: () => `/settings`,
    },
  },
}
